import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';

import Radio from '../../components/Inputs/Radio/Radio';

import {
    isBlank,
    isBlankHelperText
} from '../../helper/ValidationHelper';

export class Sabatista extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            sabatista: null,
            errors: {
                sabatista: false,
            },
            helpers: {
                sabatista: null,
            },
            disabled: {
                sabatista: false,
            },
        }
        this.isValid = this.isValid.bind(this);
    }

    // INPUTS
    handleChange = e => {
        let value = e.target.value;
        if (value === "true") value = true;
        else if (value === "false") value = false;

        this.setState({
            ...this.state,
            [e.target.name]: value,
            errors: { ...this.state.errors, [e.target.name]: false },
            helpers: { ...this.state.helpers, [e.target.name]: null },
            disabled: { ...this.state.disabled }
        });
    }

    // VALIDAÇÕES
    isValid = () => {
        const sabatistaBlank = isBlank(this.state.sabatista);

        if (sabatistaBlank) {
            this.setState({
                ...this.state,
                errors: {
                    sabatista: sabatistaBlank,
                },
                helpers: {
                    sabatista: sabatistaBlank ? isBlankHelperText() : null,
                },
                disabled: { ...this.state.disabled }
            });
            return false;
        }
        return true;
    }

    render() {
        return (
            <>
                <Grid container spacing={3}>
                    <Grid item sm={12} lg={2} style={{ marginTop: 6 }}>
                        <Radio
                            row
                            name="sabatista"
                            options={[{ value: false, label: "Não" }, { value: true, label: "Sim" }]}
                            value={this.state.sabatista}
                            helperText={this.state.helpers.sabatista}
                            error={this.state.errors.sabatista}
                            onChange={this.handleChange}
                            disabled={this.props.disabled}
                        />
                    </Grid>
                    {this.state.sabatista &&
                        <Grid item sm={12} lg={10}>
                            <Alert severity="warning">
                                <b>ATENÇÃO!</b> Ao solicitar a realização de prova em horário especial, o professor sabatista deverá chegar ao local de prova no
                                mesmo horário dos demais professores (14:30h - horário de Brasília) e aguardar em sala reservada, até o pôr do sol, para iniciar a prova.
                            </Alert>
                        </Grid>
                    }
                </Grid>
            </>
        )
    }
}

export default Sabatista;